import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Home3D from "./Home3D";

const Hero = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    window.addEventListener("orientationchange", checkMobile);

    return () => {
      window.removeEventListener("resize", checkMobile);
      window.removeEventListener("orientationchange", checkMobile);
    };
  }, []);

  return (
    <>
      <div className="hero">
        <div className="wrapper">
          <div className="content">
            <div
              className="sub-title"
              style={{translate: "none", rotate: "none", scale: "none", opacity: "1", transform: "translate(0px)"}}
            >
              Welcome
            </div>
            <h1 style={{translate: "none", rotate: "none", scale: "none", opacity: "1", transform: "translate(0px)"}}>
              <small>
                <strong>AI-Powered</strong> Integration for
              </small>{" "}
              Smart Automations.
            </h1>
            <div
              className="intro"
              style={{translate: "none", rotate: "none", scale: "none", opacity: "1", transform: "translate(0px)"}}
            >
              <p>
                Leveraging the most powerful artificial intelligence, we analyze
                crypto projects, create process automations, making it easy for you to 
                the achieve the next big success.
              </p>
            </div>
            <div
              className="btn-group"
              style={{translate: "none", rotate: "none", scale: "none", opacity: "1", transform: "translate(0px)"}}
            >
              <div className="point" style={{opacity: "0.2"}}></div>
              <Link className="btn" data-colors="primary" to="/dashboard">
                <span className="btn-txt">Launch App</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  aria-hidden="true"
                  role="img"
                  className="iconify iconify--carbon"
                  width="1em"
                  height="1em"
                  viewBox="0 0 32 32"
                >
                  <path
                    fill="currentColor"
                    d="M16.001 26.473H16L4.284 12.955L9.5 6h13l5.216 6.955l-3.24 3.737l1.513 1.31l4.295-4.957L23.5 4h-15l-6.784 9.045l12.772 14.737z"
                  ></path>
                  <path fill="currentColor" d="m20 19l7 5l-7 5z"></path>
                </svg>
                <div className="corner" data-colors="primary">
                  <span className="corner-left"></span>
                  <span className="corner-right"></span>
                  <span className="corner-top-bottom"></span>
                </div>
              </Link>
              <div
                className="lines"
                style={{translate: "none", rotate: "none", scale: "none", opacity: "1", transform: "translate(-50%, -50%)"}}
              >
                <div className="lines-wrapper">
                  <Link className="btn" data-colors="primary" to="/dashboard">
                    <span className="btn-txt">Launch App</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      aria-hidden="true"
                      role="img"
                      className="iconify iconify--carbon"
                      width="1em"
                      height="1em"
                      viewBox="0 0 32 32"
                    >
                      <path
                        fill="currentColor"
                        d="M16.001 26.473H16L4.284 12.955L9.5 6h13l5.216 6.955l-3.24 3.737l1.513 1.31l4.295-4.957L23.5 4h-15l-6.784 9.045l12.772 14.737z"
                      ></path>
                      <path fill="currentColor" d="m20 19l7 5l-7 5z"></path>
                    </svg>
                    <div className="corner" data-colors="primary">
                      <span className="corner-left"></span>
                      <span className="corner-right"></span>
                      <span className="corner-top-bottom"></span>
                    </div>
                  </Link>
                  <div className="lines-wrapper-container">
                    <svg
                      className="l1"
                      width="833"
                      height="245"
                      viewBox="0 0 833 245"
                    >
                      <path
                        id="l1"
                        d="M832 244L763 175H588L526 113H364L252 1H-100"
                      ></path>
                      <circle cx="0" cy="0" r="3" data-id="0">
                        <animateMotion
                          dur="8.386208545596059s"
                          repeatCount="indefinite"
                        >
                          <mpath href="#l1"></mpath>
                        </animateMotion>
                      </circle>
                      <circle cx="0" cy="0" r="3" data-id="1">
                        <animateMotion
                          dur="9.727864855768622s"
                          repeatCount="indefinite"
                        >
                          <mpath href="#l1"></mpath>
                        </animateMotion>
                      </circle>
                    </svg>
                    <svg
                      className="l2"
                      width="814"
                      height="250"
                      viewBox="0 0 814 250"
                    >
                      <path
                        id="l2"
                        d="M814 137H687L654 104H500L449 53H236L184 1H-86 M687 137L625 199H437L385.5 147.5H249L147 249.5H-57"
                      ></path>
                      <circle cx="0" cy="0" r="3" data-id="0">
                        <animateMotion
                          dur="8.422519916561626s"
                          repeatCount="indefinite"
                        >
                          <mpath href="#l2"></mpath>
                        </animateMotion>
                      </circle>
                      <circle cx="0" cy="0" r="3" data-id="1">
                        <animateMotion
                          dur="9.589038855611355s"
                          repeatCount="indefinite"
                        >
                          <mpath href="#l2"></mpath>
                        </animateMotion>
                      </circle>
                    </svg>
                    <svg
                      className="l3"
                      width="815"
                      height="126"
                      viewBox="0 0 815 126"
                    >
                      <path
                        id="l3"
                        d="M814 1H752L677 76H555C552 73 535 56 535 56C535 56 439 54.3333 391 56L322 125H240L217.5 102.5H-111 M814 1L766.5 48.5H705"
                      ></path>
                      <circle cx="0" cy="0" r="3" data-id="0">
                        <animateMotion
                          dur="10.167716056382297s"
                          repeatCount="indefinite"
                        >
                          <mpath href="#l3"></mpath>
                        </animateMotion>
                      </circle>
                      <circle cx="0" cy="0" r="3" data-id="1">
                        <animateMotion
                          dur="9.171647388145992s"
                          repeatCount="indefinite"
                        >
                          <mpath href="#l3"></mpath>
                        </animateMotion>
                      </circle>
                    </svg>
                    <svg
                      className="l4"
                      width="816"
                      height="143"
                      viewBox="0 0 816 143"
                    >
                      <path
                        id="l4"
                        d="M1 110H41L73 142H160L205.5 96.5H345L390.5 51H577L611 17H937 M345 96L379.5 130.5H489L517.5 102H851 M1 109.5L32.5 78H138L215 1H517L567.5 51.5"
                      ></path>
                      <circle cx="0" cy="0" r="3" data-id="0">
                        <animateMotion
                          dur="11.48285318873046s"
                          repeatCount="indefinite"
                        >
                          <mpath href="#l4"></mpath>
                        </animateMotion>
                      </circle>
                      <circle cx="0" cy="0" r="3" data-id="1">
                        <animateMotion
                          dur="10.632826004934557s"
                          repeatCount="indefinite"
                        >
                          <mpath href="#l4"></mpath>
                        </animateMotion>
                      </circle>
                    </svg>
                    <svg
                      className="l5"
                      width="833"
                      height="129"
                      viewBox="0 0 833 129"
                    >
                      <path
                        id="l5"
                        d="M1 1L37 37H134L180 83H511L581.5 12.5H960 M511 83L556.5 128.5H626L661 93.5H919"
                      ></path>
                      <circle cx="0" cy="0" r="3" data-id="0">
                        <animateMotion
                          dur="7.958993554079799s"
                          repeatCount="indefinite"
                        >
                          <mpath href="#l5"></mpath>
                        </animateMotion>
                      </circle>
                      <circle cx="0" cy="0" r="3" data-id="1">
                        <animateMotion
                          dur="11.023954780004619s"
                          repeatCount="indefinite"
                        >
                          <mpath href="#l5"></mpath>
                        </animateMotion>
                      </circle>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="analyse"
              style={{translate: "none", rotate: "none", scale: "none", opacity: "1", transform: "translate(0px)"}}
            >
              <a className="btn" data-colors="primary" href="/analysis">
                <span className="btn-txt">Analyse now</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  aria-hidden="true"
                  role="img"
                  className="iconify iconify--mage"
                  width="1em"
                  height="1em"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    d="m15.238 10.81l-.569 1.694a4.33 4.33 0 0 1-2.757 2.76l-1.713.569a.288.288 0 0 0 0 .548l1.713.569a4.32 4.32 0 0 1 2.736 2.738l.568 1.715a.287.287 0 0 0 .548 0l.59-1.694a4.32 4.32 0 0 1 2.735-2.738l1.714-.569a.288.288 0 0 0 0-.548l-1.692-.59a4.32 4.32 0 0 1-2.757-2.76l-.569-1.715a.29.29 0 0 0-.448-.126a.3.3 0 0 0-.099.148m-8.43-4.914l-.413 1.231a3.15 3.15 0 0 1-2.006 2.007l-1.246.414a.21.21 0 0 0 0 .398l1.246.415a3.14 3.14 0 0 1 1.99 1.99l.413 1.248a.21.21 0 0 0 .398 0l.43-1.232a3.15 3.15 0 0 1 1.99-1.99l1.245-.415a.21.21 0 0 0 0-.398l-1.23-.43A3.14 3.14 0 0 1 7.62 7.128l-.414-1.247a.21.21 0 0 0-.398.016m7.849-3.422l-.207.616a1.57 1.57 0 0 1-1.002 1.004l-.623.207a.104.104 0 0 0-.052.16a.1.1 0 0 0 .052.039l.623.207a1.57 1.57 0 0 1 .995.995l.206.624a.105.105 0 0 0 .2 0l.214-.616a1.57 1.57 0 0 1 .995-.995l.623-.207a.105.105 0 0 0 0-.2l-.615-.214a1.57 1.57 0 0 1-1.003-1.004l-.207-.624a.105.105 0 0 0-.199.008"
                  ></path>
                </svg>
                <div className="corner" data-colors="primary">
                  <span className="corner-left"></span>
                  <span className="corner-right"></span>
                  <span className="corner-top-bottom"></span>
                </div>
              </a>
            </div>
          </div>
        </div>
        <div className="hero-back">
            {!isMobile && <Home3D />}
          <div className="hero-back-light" style={{opacity: "1"}}></div>
          <div className="hero-back-gradient" style={{opacity: "1"}}></div>
          <div className="point" style={{opacity: "0.2"}}></div>
        </div>
      </div>
    </>
  );
};

export default Hero;
